module.exports = __webpack_public_path__ + "static/img/login_a4.256cf31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_a4.png
// module id = +QSI
// module chunks = 23